import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { getOrdinalSuffix } from '../../../components/calculation'
import CouponCode from '../couponCode';
import { useGlobalState } from '../../../globalStyle';

const PlanTable = (
    {
        checkBoxChecked,
        isuggestPlan,
        selectedPlan,
        firstFrequencyVal,
        firstPaymentVal,
        firstPaymentNote,
        paymentMethod,
        changeNote,
        formattedExpirationDate,
        setInitialState,
        frequencyUnitVal,
        setErrorMsg,
        setIsOpen,
        setSeverityMsg,
        setCouponCodeDetails,
        isActivePlan,
        setSelectedPlan,
        initialState,
        couponCodeUpdatedDetails,
        setProductPlanId,
        setSuggestPlanId,
        isCouponCodeDisplay,
        setIsCouponCodeDisplay
    }
) => {
    const couponOfferPrice = useGlobalState("offerPrice")[0];
    const price = useGlobalState("price")[0];
    const suggestPlanPrice = useGlobalState("suggestPlanPrice")[0];
    const suggestionPlanData = useGlobalState("suggestionPlanData")[0];
    const selectedPlanData = useGlobalState("selectedPlanData")[0];
    const [isCouponOpen, setIsCouponOpen] = useState(false);

    // console.log(isuggestPlan,"couponOfferPrice")

    return (
        <div>
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table" style={{ fontSize: '40px' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={2}>
                                <div className='pr-details-table-header'>Payment Summary</div>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>
                                <div className='pr-details-table'>Plan</div>
                            </TableCell>
                            <TableCell>
                                <div className='pr-details-table'>{checkBoxChecked ? isuggestPlan && isuggestPlan.plan : selectedPlan && selectedPlan.plan}</div>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                    <TableBody>
                        <TableRow>
                            <TableCell style={{ width: '45%' }}>
                                <div className='pr-details-table'>
                                    {selectedPlan && selectedPlan.offerPrice && checkBoxChecked ? "Price" :
                                        selectedPlan && selectedPlan.offerPrice && !checkBoxChecked ? "Price After Discount" :
                                            !selectedPlan.offerPrice && checkBoxChecked ? "Price" : "Price"
                                    }
                                </div>
                            </TableCell>
                            <TableCell>
                                <div className='pr-details-table'>
                                    <span>
                                        <span style={{ textDecoration: couponOfferPrice ? 'line-through' : 'none' }}>
                                            ₹{checkBoxChecked ? suggestPlanPrice.toLocaleString() : price.toLocaleString()}
                                        </span>
                                        &nbsp;
                                        {couponOfferPrice && `₹${couponOfferPrice.toLocaleString()}`}

                                    </span>

                                    <div style={{ width: '212px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'normal' }}>
                                        {paymentMethod && selectedPlan.offerPrice && selectedPlan.recurring && changeNote && !checkBoxChecked && !firstFrequencyVal && !firstPaymentVal && !firstPaymentNote && (
                                            <span style={{ fontSize: '11px', lineHeight: '16px', fontWeight: '400', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'normal', fontWeight: 'bold' }}>
                                                Effective price is ₹{Math.round(selectedPlan?.afterDiscount + selectedPlan?.afterDiscount * (selectedPlan?.gstPercent / 100)).toLocaleString()}/- You will <br />
                                                receive ₹{selectedPlan?.refundAmount}/- in your account <br />within 72 hours.
                                            </span>
                                        )}

                                        {firstFrequencyVal && firstPaymentVal && (
                                            <span style={{ fontSize: '11px', lineHeight: '16px', fontWeight: '400', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'normal', fontWeight: 'bold' }}>
                                                ₹{Math.round(selectedPlan?.firstPayment).toLocaleString()}/- for first {firstFrequencyVal > 1 ? firstFrequencyVal : ''} {frequencyUnitVal.toLowerCase()}{firstFrequencyVal > 1 ? "s" : ""} <br />
                                                then ₹{selectedPlan?.afterDiscount}/-  from {parseInt(selectedPlan?.firstFrequency) + 1} <sup>{getOrdinalSuffix(parseInt(selectedPlan?.firstFrequency) + 1)}</sup> {frequencyUnitVal.toLowerCase()} onwards
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </TableCell>
                        </TableRow>
                        {selectedPlan.offerPrice && !checkBoxChecked && <TableRow>
                            <TableCell>
                                <div className='pr-details-table'>Next Payment Amount</div>
                            </TableCell>
                            <TableCell>
                                <div className='pr-details-table'>{checkBoxChecked
                                    ? (isuggestPlan && isuggestPlan.afterDiscount)
                                        ? `₹${isuggestPlan.afterDiscount.toLocaleString()}`
                                        : `₹${isuggestPlan.price.toLocaleString()}`
                                    : `₹${selectedPlan.afterDiscount && selectedPlan.afterDiscount.toLocaleString()}`
                                }
                                </div>
                            </TableCell>
                        </TableRow>}
                        <TableRow>
                            <TableCell>
                                <div className='pr-details-table'>GST %</div>
                            </TableCell>
                            <TableCell>
                                <div className='pr-details-table'>{checkBoxChecked ? isuggestPlan && isuggestPlan.gstPercent : selectedPlan && selectedPlan.gstPercent}%</div>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <div className='pr-details-table'>Frequency</div>
                            </TableCell>
                            <TableCell>
                                <div className='pr-details-table'>
                                    {/* {paymentMethod && paymentMethod.toLowerCase() === "subscription" && checkBoxChecked
                            ? isuggestPlan.data.type : paymentMethod.toLowerCase() === "subscription"
                              ? selectedPlan.data.type
                              : "One Time Payment"} */}

                                    {checkBoxChecked ?
                                        (isuggestPlan.recurring ? isuggestPlan.data.type : "One Time Payment") :
                                        (selectedPlan.recurring ? selectedPlan.data.type : "One Time Payment")
                                    }

                                </div>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <div className='pr-details-table'>
                                    {checkBoxChecked ?
                                        (isuggestPlan.recurring ? "Mandate Expiry" : "Subscription Expiry") :
                                        (selectedPlan.recurring ? "Mandate Expiry" : "Subscription Expiry")
                                    }
                                </div>
                            </TableCell>
                            <TableCell>
                                <div className='pr-details-table'>
                                    {/* {checkBoxChecked && !isuggestPlan.recurring ? isuggestPlan.frequency + isuggestPlan.frequencyUnit : formattedExpirationDate} */}
                                    {formattedExpirationDate}
                                </div>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <div className='pr-details-table'>GSTIN No.</div>
                            </TableCell>
                            <TableCell>
                                <TextField
                                    id="gst"
                                    label="GSTIN No."
                                    placeholder="Please enter GSTIN Number (optional)"
                                    type="text"
                                    fullWidth
                                    margin="dense"
                                    value={initialState.gst}
                                    InputLabelProps={{
                                        style: { fontSize: 10 },
                                    }}
                                    inputProps={{ style: { fontSize: 12, height: 5 } }}
                                    onChange={(e) => setInitialState({ ...initialState, gst: e.target.value })}
                                />
                                <p className='small  pr-details-table'>BP Equities GST No. 27AAACB4602L2ZT</p>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            {isCouponCodeDisplay && <CouponCode productDetails={checkBoxChecked ? isuggestPlan : selectedPlan} setErrorMsg={setErrorMsg}
                setIsOpens={setIsOpen} setSeverityMsg={setSeverityMsg} setCouponDetailsData={setCouponCodeDetails}
                selectedPlan={selectedPlan} isActivePlan={isActivePlan} setSelectedPlan={setSelectedPlan} initialState={initialState}
                checkBoxChecked={checkBoxChecked} couponCodeUpdatedDetails={couponCodeUpdatedDetails} setProductPlanId={setProductPlanId} setSuggestPlanId={setSuggestPlanId} setIsCouponCodeDisplay={setIsCouponCodeDisplay} />}
        </div>
    )
}

export default PlanTable;